/* global ace */
// Note: ace javascript source code needs to be included on each page where this functionality will be used
// (it isn't included in pages by default)
(function ($) {    
    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    $.fn.codeEditor = function () {
        if (ace === undefined) {
            return this;
        }
        this.each(function () {
            const defaults = {
                height: 150,
                theme: 'twilight',
                readonly: true,
                mode: 'javascript'
            };
            const options = $.extend({}, defaults, $(this).data());
            this.style.height = options.height + "px";
            const editor = ace.edit(this);
            editor.setTheme('ace/theme/' + options.theme);
            editor.setReadOnly(options.readonly);
            editor.session.setMode('ace/mode/' + options.mode);
        });

        return this;
    };
}(jQuery));